// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d39ea035","145":"852534ed","313":"f3e52549","344":"dda58189","467":"76919aa6","712":"aed91356","989":"27661ba6"}[chunkId] + ".chunk.js";
};